import certificateSubjects from './components/certificateSubjects';

export default {
  routes: [
    {
      path: '/',
      component:certificateSubjects,
      name:'certificateSubjects'
    },
  ]
};
